<template>
  <div>
    <h2 v-if="!noData" class="ml-6 pb-4 text-5xl font-bold" :class="percentageClass">{{ percentage }}%</h2>
    <div id="treatment-chart" class="w-full" />
  </div>
  <TheNoResult
    v-if="noData"
    :image="imgUrl"
    :title="$t('pages.review.reviewAnalyticsPage.chart.noResults.title')"
    :description="$t('pages.review.reviewAnalyticsPage.chart.noResults.description')"
  />
</template>

<script>
import TheNoResult from '@/components/layout/TheNoResult.vue'
import { PieChart } from '@/components/charts/PieChart'
import useReview from '@/composables/review'
import ApexChart from 'apexcharts'

export default {
  components: {
    TheNoResult
  },
  props: {
    percentage: {
      type: Number,
      required: true
    }
  },
  setup() {
    const { reviewStatistics } = useReview()
    const imgUrl = computed(
      () => `${import.meta.env.VITE_AWS_STORAGE_URL}/review-analytics/review-average-treatment.png`
    )
    return {
      reviewStatistics,
      imgUrl
    }
  },
  data: () => {
    return {
      chartInstance: null,
      chart: new PieChart()
    }
  },
  computed: {
    noData() {
      return !this.data[0] && !this.data[1]
    },
    data() {
      return [this.reviewStatistics.reviewsReplied, this.reviewStatistics.reviewsNotReplied]
    },
    percentageClass() {
      if (this.percentage < 50) {
        return 'text-red-500'
      } else if (this.percentage >= 50 && this.percentage < 75) {
        return 'text-yellow-400'
      } else {
        return 'text-green-500'
      }
    }
  },
  mounted() {
    this.initChart()
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
  },
  methods: {
    initChart() {
      if (!this.noData) {
        const chartElement = this.createElement('treatment-chart')
        this.chart.setColor(['#22c55e', '#ef4444'])
        this.chart.setSeries(this.data)
        this.chart.setLabels([
          this.$t('pages.review.reviewAnalyticsPage.treatmentRate.legends.opinionsTreated'),
          this.$t('pages.review.reviewAnalyticsPage.treatmentRate.legends.opinionsUntreated')
        ])
        this.chartInstance = new ApexChart(chartElement, this.chart.options)
        this.chartInstance.render()
      }
    },
    createElement(ref) {
      let elem = document.getElementById(ref)
      let chartElement = document.createElement('div')
      chartElement = elem.appendChild(chartElement)
      chartElement.setAttribute('id', `${ref}-apex`)
      return chartElement
    }
  }
}
</script>
